import "./dashboard.scss";

export default function Dashboard() {
  return <h1>Dashboard</h1>;
}
